import React, { useEffect, useState } from 'react';
import api from '../services/api';
import toast from 'react-hot-toast';
import AjudaTooltip from '../components/AjudaTooltip';
import ModalConfirmacao from '../components/ModalConfirmacao';

function FormasPagamento() {
  const [formas, setFormas] = useState([]);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState({ nome: '', parcelado: false, tem_dia_vencimento: false });
  const [formEdicao, setFormEdicao] = useState({});
  const [confirmacao, setConfirmacao] = useState({ aberto: false, id: null, nome: '' });

  async function carregar() {
    const response = await api.get('/formas-pagamento');
    setFormas(response.data);
  }

  useEffect(() => { carregar(); }, []);

  async function criar() {
    if (!form.nome.trim()) { toast.error('Nome é obrigatório!'); return; }
    try {
      await api.post('/formas-pagamento', form);
      setForm({ nome: '', parcelado: false, tem_dia_vencimento: false });
      setMostrarForm(false);
      carregar();
      toast.success('Forma de pagamento cadastrada!');
    } catch (err) {
      toast.error(err.response?.data?.mensagem || 'Erro ao cadastrar.');
    }
  }

  function iniciarEdicao(f) {
    setEditando(f.formapagamentoid);
    setFormEdicao({ ...f });
  }

  async function salvarEdicao() {
    if (!formEdicao.nome?.trim()) { toast.error('Nome é obrigatório!'); return; }
    await api.put(`/formas-pagamento/${editando}`, formEdicao);
    setEditando(null);
    carregar();
    toast.success('Forma de pagamento atualizada!');
  }

  async function remover(id) {
    await api.delete(`/formas-pagamento/${id}`);
    carregar();
    toast.success('Forma de pagamento removida!');
  }

  async function confirmarDeletar() {
    await remover(confirmacao.id);
    setConfirmacao({ aberto: false, id: null, nome: '' });
  }

  return (
    <div>
      <div className="page-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <h2 style={{ margin: 0 }}>💳 Formas de Pagamento</h2>
          <AjudaTooltip texto={`Configure as formas de pagamento do escritório.\n\n• Parcelado: marque se o pagamento é dividido em parcelas. Será solicitado o número de parcelas ao usar esta forma.\n\n• Dia fixo de vencimento mensal: marque quando o pagamento cai todo mês no mesmo dia (ex: PIX parcelado todo dia 10). Ao usar, você informa o dia e o sistema calcula o prazo final automaticamente.`} />
        </div>
        <button className="btn-primary" onClick={() => setMostrarForm(!mostrarForm)}>
          {mostrarForm ? 'Cancelar' : '+ Nova Forma'}
        </button>
      </div>

      {mostrarForm && (
        <div className="card">
          <h3>Nova Forma de Pagamento</h3>
          <input
            placeholder="Nome * (Ex: PIX à vista)"
            value={form.nome}
            onChange={e => setForm({ ...form, nome: e.target.value })}
          />
          <div style={{ display: 'flex', gap: 24, marginBottom: 12 }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 14, cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={form.parcelado}
                onChange={e => setForm({ ...form, parcelado: e.target.checked })}
                style={{ width: 'auto', marginBottom: 0 }}
              />
              Parcelado: exige número de parcelas
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 14, cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={form.tem_dia_vencimento}
                onChange={e => setForm({ ...form, tem_dia_vencimento: e.target.checked })}
                style={{ width: 'auto', marginBottom: 0 }}
              />
              Dia fixo de vencimento mensal
            </label>
          </div>
          <button className="btn-primary" onClick={criar}>Salvar</button>
        </div>
      )}

      <div className="card">
        <h3>Formas Cadastradas</h3>
        <table>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Parcelado</th>
              <th>Vencimento Mensal</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {formas.map((f) => (
              editando === f.formapagamentoid ? (
                <tr key={f.formapagamentoid} style={{ background: '#f0f7ff' }}>
                  <td data-label="Nome">
                    <input value={formEdicao.nome} onChange={e => setFormEdicao({ ...formEdicao, nome: e.target.value })} style={{ marginBottom: 0 }} />
                  </td>
                  <td data-label="Parcelado">
                    <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
                      <input type="checkbox" checked={!!formEdicao.parcelado}
                        onChange={e => setFormEdicao({ ...formEdicao, parcelado: e.target.checked })}
                        style={{ width: 'auto', marginBottom: 0 }} />
                      Parcelado
                    </label>
                  </td>
                  <td data-label="Vencimento Mensal">
                    <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
                      <input type="checkbox" checked={!!formEdicao.tem_dia_vencimento}
                        onChange={e => setFormEdicao({ ...formEdicao, tem_dia_vencimento: e.target.checked })}
                        style={{ width: 'auto', marginBottom: 0 }} />
                      Dia fixo
                    </label>
                  </td>
                  <td data-label="Ações">
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button className="btn-primary" style={{ fontSize: 12, padding: '5px 10px' }} onClick={salvarEdicao}>Salvar</button>
                      <button className="btn-secondary" style={{ fontSize: 12, padding: '5px 10px' }} onClick={() => setEditando(null)}>Cancelar</button>
                    </div>
                  </td>
                </tr>
              ) : (
                <tr key={f.formapagamentoid}>
                  <td data-label="Nome">{f.nome}</td>
                  <td data-label="Parcelado">
                    <span style={{ background: f.parcelado ? '#d1e7dd' : '#f0f0f0', color: f.parcelado ? '#0f5132' : '#666', padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600 }}>
                      {f.parcelado ? 'Sim' : 'Não'}
                    </span>
                  </td>
                  <td data-label="Vencimento Mensal">
                    <span style={{ background: f.tem_dia_vencimento ? '#d1e7dd' : '#f0f0f0', color: f.tem_dia_vencimento ? '#0f5132' : '#666', padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600 }}>
                      {f.tem_dia_vencimento ? 'Sim' : 'Não'}
                    </span>
                  </td>
                  <td data-label="Ações">
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button className="btn-secondary" style={{ fontSize: 12, padding: '5px 10px' }} onClick={() => iniciarEdicao(f)}>Editar</button>
                      <button className="btn-danger" style={{ fontSize: 12, padding: '5px 10px' }} onClick={() => setConfirmacao({ aberto: true, id: f.formapagamentoid, nome: f.nome })}>Remover</button>
                    </div>
                  </td>
                </tr>
              )
            ))}
            {formas.length === 0 && (
              <tr><td colSpan={4} style={{ textAlign: 'center', color: '#999' }}>Nenhuma forma de pagamento cadastrada</td></tr>
            )}
          </tbody>
        </table>
      </div>

      <ModalConfirmacao
        aberto={confirmacao.aberto}
        titulo="Excluir forma de pagamento"
        mensagem={`Tem certeza que deseja excluir "${confirmacao.nome}"? Esta ação não pode ser desfeita.`}
        onConfirmar={confirmarDeletar}
        onCancelar={() => setConfirmacao({ aberto: false, id: null, nome: '' })}
      />
    </div>
  );
}

export default FormasPagamento;
